export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./lk-breadcrumbs.vue?vue&type=template&id=546bff12&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-breadcrumbs/lk-breadcrumbs.vue?vue&type=template&id=546bff12&
// module id = 1372
// module chunks = 0